import React from 'react';
import BackOfficeSection from '../components/BackOfficeSection';

const BackOfficePage = () => {
  return (
    <div className="backoffice-page">
      <BackOfficeSection />
    </div>
  );
};

export default BackOfficePage;
